import axios from 'axios';
import DossierSummary from '@/dossier/models/DossierSummary';
import { parseDossierSummaries, formatDossierSearchBody } from '../converters/statusBoardConverters';
import { DossierSearchCriteria } from '../models/DossierSearchCriteria';

export interface DossierSearchCursor {
  __dossierSearchCursor: number;
}

export interface DossierPage {
  dossiers: Array<DossierSummary>;
  nextCursor: DossierSearchCursor | null;
}

export default class StatusBoardClient {
  static async search(criteria: DossierSearchCriteria, cursor?: DossierSearchCursor, pageSize = 20): Promise<DossierPage> {
    // cursor is treated as offset because cursor pagination is currently not supported by the backend
    const offset = cursor === undefined ? 0 : (cursor as any as number);

    const params = {
      skip: offset,
      take: pageSize,
      contactsvisible: criteria.includeContacts ?? false,
      mechanicsvisible: criteria.includeMechanics ?? false,
    };

    const response = await axios.post('/api/mobopro/v3/dossiers/scrumboard', formatDossierSearchBody(criteria), { params });

    const dossiers = parseDossierSummaries(response.data.dossiers);
    return {
      dossiers,
      nextCursor: response.data.moreDossiersAvailable ? (offset + pageSize) as any : null,
    };
  }
}